import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

const UpdateTeamMessage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: '',
    type: 'horizontal',
    is_active: true,
    image: null,
    video: null,
    video_url: '',
    existingImage: '',
    existingVideo: ''
  });

  // Fetch message by ID
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}message/${id}`)
      .then((res) => {
        const item = res.data?.data || res.data;
        setFormData({
          title: item.title || '',
          type: item.type || 'horizontal',
          is_active: item.is_active === 0 ? false : true,
          image: null,
          video: null,
          video_url: item.video_url || '',
          existingImage: item.image ? `${process.env.REACT_APP_BACKEND_URL_REL}messages/${item.image}` : '',
          existingVideo: item.video ? `${process.env.REACT_APP_BACKEND_URL_REL}messages/${item.video}` : ''
        });
      })
      .catch((err) => {
        console.error('Error fetching advertisement:', err);
      });
  }, [id]);

  const isVideoType = formData.type === 'video';

  const handleChange = (e) => {
    const { name, value, files, checked } = e.target;
    if (name === 'image') {
      setFormData({ ...formData, image: files[0] });
    } else if (name === 'video') {
      setFormData({ ...formData, video: files[0] });
    } else if (name === 'is_active') {
      setFormData({ ...formData, is_active: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedData = new FormData();
    updatedData.append('title', formData.title);
    updatedData.append('type', formData.type);
    updatedData.append('is_active', formData.is_active ? 1 : 0);

    if (formData.video_url) {
      updatedData.append('video_url', formData.video_url);
    }

    if (formData.image instanceof File) {
      updatedData.append('image', formData.image);
    }

    if (formData.video instanceof File) {
      updatedData.append('video', formData.video);
    }

    axios
      .patch(`${process.env.REACT_APP_BACKEND_URL}message/${id}`, updatedData) // ✅ PATCH
      .then(() => {
        alert('Advertisement updated successfully!');
        navigate('/team-message/list');
      })
      .catch((err) => {
        console.error('Update failed:', err);
        alert('Failed to update advertisement');
      });
  };

  return (
    <div className="max-w-xl mx-auto mt-10 p-6 bg-white shadow-md rounded-md">
      <h2 className="text-2xl font-bold mb-6">Update Advertisement</h2>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="mb-4">
          <label htmlFor="title" className="block mb-1 font-semibold">
            Title
          </label>
          <input
            id="title"
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="type" className="block mb-1 font-semibold">
            Type
          </label>
          <select
            id="type"
            name="type"
            value={formData.type}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            required
          >
            <option value="horizontal">Horizontal</option>
            <option value="vertical">Vertical</option>
            <option value="video">Video</option>
          </select>
        </div>

        {!isVideoType && (
          <div className="mb-4">
            <label htmlFor="image" className="block mb-1 font-semibold">
              Upload Image
            </label>
            <input id="image" type="file" name="image" accept="image/*" onChange={handleChange} className="w-full" />

            {formData.image ? (
              <img src={URL.createObjectURL(formData.image)} alt="preview" className="mb-4 mt-2 w-32 rounded" />
            ) : formData.existingImage ? (
              <img src={formData.existingImage} alt="existing" className="mb-4 mt-2 w-32 rounded" />
            ) : null}
          </div>
        )}

        {isVideoType && (
          <>
            <div className="mb-4">
              <label htmlFor="video" className="block mb-1 font-semibold">
                Upload Video File (optional)
              </label>
              <input id="video" type="file" name="video" accept="video/*" onChange={handleChange} className="w-full" />

              {formData.video ? (
                <video src={URL.createObjectURL(formData.video)} className="mb-4 mt-2 w-64 rounded" controls>
                  <track kind="captions" />
                </video>
              ) : formData.existingVideo ? (
                <video src={formData.existingVideo} className="mb-4 mt-2 w-64 rounded" controls>
                  <track kind="captions" />
                </video>
              ) : null}
            </div>

            <div className="mb-4">
              <label htmlFor="video_url" className="block mb-1 font-semibold">
                Video URL (YouTube / Shorts / other)
              </label>
              <input
                id="video_url"
                type="text"
                name="video_url"
                value={formData.video_url}
                onChange={handleChange}
                placeholder="https://youtube.com/shorts/... or https://youtu.be/..."
                className="w-full border rounded px-3 py-2"
              />
            </div>
          </>
        )}

        <div className="mb-4 flex items-center gap-2">
          <input id="is_active" type="checkbox" name="is_active" checked={formData.is_active} onChange={handleChange} />
          <label htmlFor="is_active" className="font-semibold">
            Active
          </label>
        </div>

        <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition">
          Update Advertisement
        </button>
      </form>
    </div>
  );
};

export default UpdateTeamMessage;